import handleAuthorizedRoutes from "@/services/modules/authorizedRoutes";

const state = () => ({
    authorizedRoutes: []
})

const mutations = {
    setAuthorizedRoutes: (state, authorizedRoutes) => {
        state.authorizedRoutes = authorizedRoutes
    }
}

const actions = {
    async getAuthorizedRoutes({state, commit}, query) {
        if (state.authorizedRoutes && state.authorizedRoutes.length > 0) {
            return state.authorizedRoutes;
        }

        if (!query || !query.company_id) {
            return [];
        }
        const {getAuthorizedRoutes} = handleAuthorizedRoutes();
        const queryString = '?' + new URLSearchParams(query).toString();

        try {
            const response = await getAuthorizedRoutes(queryString);
            if (response.data && response.data.length) {
                commit('setAuthorizedRoutes', response.data);
            }
            return response.data;
        } catch (error) {
            return [];
        }
    }
}

export default {
    namespaced: true,
    actions,
    mutations
}